import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { CartService } from "src/app/components/shared/services/cart.service";
import { ProductService } from "src/app/components/shared/services/product.service";
import { WishlistService } from "src/app/components/shared/services/wishlist.service";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { Product } from "src/app/modals/product.model";
import { ProductDialogComponent } from "../product-dialog/product-dialog.component";
import { ItemsService } from "src/app/services/items.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CartDialogComponent } from "src/app/components/pages/cart-dialog/cart-dialog.component";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.sass"],
})
export class ProductComponent implements OnInit {
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  // @Input() product: Product;
  @Input()
  set product(value: any) {
    this._product = value;
    this.inicializar();
  }

  public _product: any;
  public atributosECOrdenados: any[] = [];
  constructor(
    private cartService: CartService,
    public productsService: ProductService,
    private wishlistService: WishlistService,
    private dialog: MatDialog,
    private router: Router,
    private itemService: ItemsService,
    private spinner: NgxSpinnerService
  ) {}
  url: any;
  estrellas: number = 5;
  valProm: number = 0;
  ngOnInit() {
    this.url = document.location.href.split("#");
    window.scrollTo(0, 0);
    // window.onhashchange  = function () {
    //   //Do whatever here for example prompt user
    //   if(sessionStorage.getItem('marca') != null){

    //   }
    // };
  }

  inicializar() {
    window.scrollTo(0, 0);
    const atributos = Array.isArray(this._product.itemsEC_Atributos_List)
      ? this._product.itemsEC_Atributos_List
      : [];
    this.atributosECOrdenados = [
      ...atributos.filter(
        (atributo) =>
          atributo.TipoAtributoEC === "TXT" ||
          atributo.TipoAtributoEC === "TXTICO"
      ),
      ...atributos.filter(
        (atributo) => atributo.TipoAtributoEC === "ICO"
      ),
    ];

    if (this._product.ValProm == null) {
      this.valProm = 0;
    } else {
      this.valProm = this._product.ValProm;
    }
  }
  // Add to cart
  public addToCart(product: Product, quantity: number = 1) {
    alert("Muy pronto estara disponible!")
    //   if (quantity == 0 || product.SaldoG == 0) return false;

    //   if (sessionStorage.getItem("tp") == null) {
    //     sessionStorage.setItem("tp", "TA");
    //     product.PVVenta = product.PV2;
    //   } else {
    //     if (sessionStorage.getItem("tp") == "TA") {
    //       product.PVVenta = product.PV2;
    //     } else {
    //       product.PVVenta = product.PV3;
    //     }
    //   }
    
    // if(product.PV2 > 0){
    //   this.cartService.addToCart(product, quantity);
    //   this.dialog.open(CartDialogComponent, {
    //     data: null,
    //     panelClass: "product-dialog",
    //     width: "800px",
    //   });
    // }
  }

  // Add to wishlist
  public addToWishlist(product: Product) {
    this.wishlistService.addToWishlist(product);
  }

  // Add to compare
  public addToCompare(product: Product) {
    this.productsService.addToCompare(product);
  }

  public openProductDialog(product) {
    let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: "product-dialog",
      width: "850px"
    });
  }
  async verProducto(idItem: number) {
    this.spinner.show();
    await this.itemService.sumarClic(idItem);
    this.router.navigate(["/home/product", idItem])
  }
  enviarMensajeWsp() {
    const formData = {
      phone: "933288799",
      date:
        "%0ACodigo: " +
        this._product.CodigoBarras +
        "%0ANombre Item: " +
        this._product.NombreItm +
        "%0AUrl: novaplaza.pe/%23/home/product/" +
        this._product.idItem,
    };

    const URL = `https://api.whatsapp.com/send?phone=${formData.phone}&text=Hola busco este Producto,%20${formData.date}%20&source=&data=`;
    window.open(URL, "_blank");
  }
}
